import Vue from 'vue'

export default {
  setLikesIt(state, { foreignType, foreignId, likesIt }) {
    Vue.set(state.likes, `${foreignType}__${foreignId}`, likesIt)
  },
}
